import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import Select from 'react-select';

const ProductModelCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [code, setCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [gstRate, setGstRate] = useState("");
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        fetchBrandTypes();
    }, [isAuthenticated, companyId, token, logout]);

    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState(null);

    const fetchBrandTypes = async () => {
        try {
            const response = await fetchData('BrandApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setRequestTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Brand Types:', error);
        }
    };

    const handleBrandChange = async (selectedOption) => {
        setSelectedRequestType(selectedOption);
    };

    const clearForm = () => {
        setName("");
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!name) {
            setErrorMessage("All fields are required!");
            setisSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Model: name,
            BrandId : selectedRequestType.value,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('ProductModalApi', CreateData, token)
            .then((response) => {
                console.log('Product Model Created success:', response);
                setSuccessMessage("Product Model Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/ModelIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>PRODUCT MODEL CREATE</h6>
                        <Tooltip title="Exit">
                            <Link to="/ModelIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Back-To-List <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>

                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                               Brand
                            </label>
                            <Select
                                value={selectedRequestType}
                                onChange={handleBrandChange}
                                options={requestTypeOptions}
                                placeholder="Select Brand"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                                Product Model
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </Fragment>
    );
}

export default ProductModelCreate;

